import RetailApiV2 from '@/api/retailApi/RetailApiV2'

export interface Notice {
  id: number
  text: string
  severity: string
  color: string
  iconPath: string
  link: string
  showTimer: boolean
  closedInterval: string
  validTo: string
}

interface NoticesResponse {
  notices: Notice[]
}

export const NOTICE_COLOR_MAP: Record<string, string> = {
  blue:         '#1a4fa0',
  olive_green:  '#4a6741',
  dark_orange:  '#c45b1a',
  dark_brown:   '#4a2e1a',
  bordeaux_red: '#7a1a2e',
  purple:       '#a106f4',
  dark_purple:  '#1d001f',
}

export function noticeColorBg(color: string): string {
  return NOTICE_COLOR_MAP[color] ?? '#1d001f'
}

export class NoticeService {
  async loadInfoNotices(limit = 6): Promise<Notice[]> {
    const { data } = await RetailApiV2.get(`notices?severity=info&limit=${limit}`) as { data: NoticesResponse }
    return data?.notices ?? []
  }
}

export const noticeService = new NoticeService()
